import { Pipe, PipeTransform } from '@angular/core';
import { FilterService } from '../services/filter.service';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderbyPipe implements PipeTransform {

	constructor(private _fS: FilterService) { }

	transform(array: any[], orderBy: any[], refresh: number = 1): any {
		if (!orderBy) return array;
		return this._fS.sortByMultiplesArguments(array, orderBy);
	}

}